import { Col, DatePicker, Form, Row } from 'antd'
import React from 'react'
import { t } from 'i18next'
import TextArea from 'antd/es/input/TextArea'

export default function BoxMaintenanceForm ({ form, onFinish }) {
  const onSubmit = (values) => {
    onFinish(values)
  }

  return (
    <Form
      id="MaintenanceFormAdmin"
      size='small'
      form={form}
      labelAlign='left'
      layout='vertical'
      onFinish={onSubmit}
    >
      <Row gutter={16}>ABC
        <Col>
          <Form.Item name="end_date" label={t('Admin.BoxMaintenanceForm.end_date')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <DatePicker showTime={{ format: 'HH:mm' }} format="DD/MM/YYYY HH:mm" />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="comment" label={t('Admin.BoxMaintenanceForm.comment')}
            rules={[{ required: true, message: t('rules.required') }]}>
        <TextArea rows={5} />
      </Form.Item>
    </Form>
  )
}
